// ── Nacherfassung: result list / form actions ───────────────────────────────
// Replaces the inline onclick handlers of the module: confirm dialog on the
// direct-ticket link, the legitimation popup window, row-click navigation on
// result cells (td[data-href]) and location buttons (button[data-href]).
(function () {
    'use strict';

    if (!document.getElementById('regcompl_main') &&
        !document.querySelector('a.direct_ticket, [data-legi-window-url], td[data-href], button[data-href]')) return;

    document.addEventListener('click', function (e) {
        if (!(e.target instanceof Element)) return;

        var ticketLink = e.target.closest('a.direct_ticket');
        if (ticketLink) {
            // Unpatched templates render no data-confirm; fall back to the
            // module's default text so ticket creation stays guarded.
            var confirmText = ticketLink.getAttribute('data-confirm') ||
                'Please confirm to create a free ticket for this person';
            if (!window.confirm(confirmText)) {
                e.stopPropagation();
                e.preventDefault();
            }
            return;
        }

        var legiButton = e.target.closest('[data-legi-window-url]');
        if (legiButton) {
            var win = window.open(
                legiButton.getAttribute('data-legi-window-url'),
                'newwindow',
                'height=900, width=900, left=10, top=60, toolbar=no, scrollbars=yes, resizable=yes'
            );
            if (win) win.focus();
            return;
        }

        var hrefEl = e.target.closest('td[data-href], button[data-href]');
        if (hrefEl) {
            // Real links/controls inside a clickable cell keep their own behaviour.
            if (hrefEl.tagName === 'TD' && e.target.closest('a, button, input, select, label')) return;
            document.location.href = hrefEl.getAttribute('data-href');
        }
    });
})();
